/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import MaterialInput from 'components/common/MaterialInput'
import MaterialSelectWithDropdown from 'components/common/MaterialSelectWithDropdown'
import $t from 'i18n'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import { getMember } from 'utils/memberUtils'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

import './ZipcodeValidationField.css'

const ZipcodeValidationField = ({ memberId, errors, onChange, disabled }) => {
  const dispatch = useDispatch()
  const member = useSelector(state => getMember(state, memberId))
  const { isZipCodeValidating, countyList } = useSelector(state => state.member)
  const zipCode = member?.homeAddress?.zipCode
  const selectedCounty = member?.homeAddress?.county

  const showCountyDropdown = countyList?.length > 1

  const SINGLE_COUNTY_ZIPCODE_MATCH = 1

  useEffect(() => {
    if (countyList?.length === SINGLE_COUNTY_ZIPCODE_MATCH) {
      dispatch(
        Actions.createAction(Actions.UPDATE_COUNTY, {
          county: countyList?.[0]?.value,
          memberId
        })
      )
    }
  }, [countyList])

  useEffect(() => {
    // send to parent component the updated zipcode and county for every change
    if (onChange) {
      onChange(zipCode, selectedCounty)
    }
  }, [zipCode, selectedCounty])

  const onZipcodeChange = e => {
    const zip = e.target.value
    if (zip?.length <= 5) {
      dispatch(
        Actions.createAction(Actions.UPDATE_ZIP_CODE, {
          zipcode: zip,
          memberId
        })
      )
      if (zip?.length === 5) {
        dispatch(
          Actions.createAction(Actions.VALIDATE_ZIP_CODE_REQUESTED, {
            zipcode: zip,
            memberId
          })
        )
      }
    }
  }

  const onCountyChange = value => {
    dispatch(
      Actions.createAction(Actions.UPDATE_COUNTY, {
        county: value,
        memberId
      })
    )
  }

  return (
    <div className='zipcode-validation-field'>
      <MaterialInput
        className='zip-input'
        type='number'
        value={zipCode || ''}
        onChange={onZipcodeChange}
        label={$t('fields.zip')}
        disabled={isZipCodeValidating || disabled}
        max={99999}
        min={0}
        errorText={errors?.zipCode}
      />
      {isZipCodeValidating && (
        <Spin
          className='input-loading'
          indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />}
        />
      )}
      {showCountyDropdown && (
        <MaterialSelectWithDropdown
          className='county-input'
          value={selectedCounty}
          onChange={onCountyChange}
          errorText={errors?.county}
          data={countyList}
          label={$t('fields.county')}
        />
      )}
    </div>
  )
}

export default ZipcodeValidationField
